<template>
<div class="equip_wrap">
  <div class="filter_list">
  </div>
  <div class="data_list">
  <el-table
          :data="tableData"
          highlight-current-row
          :style="'width: 100%;overflow-y:auto;margin-top:-10px'"
          :header-cell-style="{background:'#FFF',color:'#212121'}">
        <el-table-column
            type="index"
            label="序号"
            align="left"
            :index="indexMethod"
            width="50"/>
    <el-table-column label="备注" align="left" >
      <template slot-scope="scope">
        <span>{{scope.row.remark}}</span>
      </template>
    </el-table-column>

    <el-table-column  prop="insertTime" label="备注时间" align="left" /></el-table>
    </div>
  <div class="pagination">
    <el-pagination background @current-change="handleCurrentChange" layout="prev, pager, next,total" :total="searchOption.totalCount" :page-size="10">
    </el-pagination>
  </div>
</div>
</template>
<script>
import orderApi from "@/api/orderpre";
import {formatAlarmType,formatAlarm} from '../api/orderview';

export default {
  data() {
    return {
      bindEquipVisible:false,
      searchOption: {
        name: '',
        pageSize:'10',
        totalCount:1,
        pageNum:1,
        orderSn: '',
        vehicleSn: '',
        userName: '',
        warnType: '',
        city: '',
        status:'',
        clearStatus:'',
        orderStatus:'',
        cur_page: 1,
        autoload:'30',
      },
      tableData: [],
    }
  },
  props:{
    orderNum:String
  },
  comments:{
  },
  mounted() {
    this.loadData()
  },
  methods:{
    handleSearch(){
      this.loadData()
    },
    loadData(){
      let param = {
        pageNum:this.searchOption.pageNum,
        pageSize:this.searchOption.pageSize,
        orderNumber:this.orderNum,

      }
      orderApi.ViewRemark(param).then(res=>{
        if(res.code == 0) {
          this.tableData = res.result.list
          this.searchOption.totalCount = res.result.total
        }
      })
    },
    formatAlarmType(v){
      return formatAlarmType(v)
    },
    formatAlarm(typeAlarm,warnName,fenceName,macid,entity_factory){
      return formatAlarm(typeAlarm,warnName,fenceName,macid,entity_factory)
    },
    handleCurrentChange(val){
      this.searchOption.pageNum = val
      this.loadData()
    },
    indexMethod(index){
      let curPage = this.searchOption.pageNum
      let pageSize = this.searchOption.pageSize
      return (index+1)+(curPage-1)*pageSize
    }
  }
}
</script>
<style scoped>
.equip_wrap{
  display: flex;
  flex-direction: column;
}
.filter_list{
  display: flex;
  flex-direction: row;
}
.searchBtn{
  height: 30px;
  background: #3b7Bcf;
}
.handle-input {
  width: 200px;
  display: inline-block;
}
.dialog_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  color: #FFF;
}
</style>
<style less>
.el-dialog__header {
  background: rgb(26,36,62);
  display: flex;
}
</style>
